/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { appPalette, appType, type Palette, type TypePair } from '@sidekick/design-tokens';
import type { CSSProperties } from 'react';

/**
 * Ported from apps/web/design-reference/wordmark.jsx.
 *
 * Three leads — serif (editorial, default), grotesque (modern, software),
 * humanist (looser middle ground). The brand brief leaves the final
 * choice open; serif is the default per Option A.
 */
export type WordmarkLead = 'serif' | 'grotesque' | 'humanist';

export interface WordmarkProps {
  lead?: WordmarkLead;
  palette?: Palette;
  type?: TypePair;
  size?: number;
  color?: string;
  weight?: number;
}

const leadStyle = (lead: WordmarkLead, type: TypePair, weight: number | undefined): CSSProperties => {
  switch (lead) {
    case 'serif':
      return {
        fontFamily: type.serif,
        fontWeight: weight ?? 400,
        letterSpacing: '-0.02em',
        fontStyle: 'normal',
        fontFeatureSettings: type.serifFeat,
      };
    case 'grotesque':
      return {
        fontFamily: type.sans,
        fontWeight: weight ?? 500,
        letterSpacing: '-0.045em',
      };
    case 'humanist':
      return {
        fontFamily: type.sans,
        fontWeight: weight ?? 400,
        letterSpacing: '-0.02em',
      };
  }
};

export function Wordmark({
  lead = 'serif',
  palette = appPalette,
  type = appType,
  size = 56,
  color,
  weight,
}: WordmarkProps) {
  return (
    <span
      style={{
        display: 'inline-block',
        fontSize: size,
        lineHeight: 0.9,
        color: color ?? palette.fg,
        ...leadStyle(lead, type, weight),
      }}
    >
      second
    </span>
  );
}
